module.exports = __webpack_public_path__ + "img/catering_active.5c3032b5.png";